import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function useGrowthAward() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const getGrowthAward = useCallback(async () => {
    const fetchUrl = `${baseUrl}growthawards`;

    const response = await customFetch(fetchUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });

    return response;
  }, [authResult, customFetch]);

  const getGrowthAwardResponses = useCallback(
    async (appId: number) => {
      const fetchUrl = `${baseUrl}growthawardresponses?applicationId=${appId}`;

      const response = await customFetch(fetchUrl, {
        method: 'GET',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
      });

      const match = response.find((res: any) => res.applicationId == appId) ?? [];
      return match;
    },
    [authResult, customFetch]
  );

  const postGrowthAwardResponses = useCallback(
    async (postInfo: any[]) => {
      const fetchUrl = `${baseUrl}growthawardresponses`;
      const response = await customFetch(fetchUrl, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },

        body: JSON.stringify(postInfo),
      });
      const results = await response;

      return response;
    },
    [authResult, customFetch]
  );

  const deleteGrowthAwardResponse = useCallback(
    async (activityId: number, applicationId: number) => {
      const postInfo = {
        applicationId: applicationId,
        growthAwardActivityId: activityId,
      };

      const fetchUrl = `${baseUrl}growthawardresponses`;
      const response = await customFetch(fetchUrl, {
        method: 'DELETE',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },

        body: JSON.stringify(postInfo),
      });

      return response;
    },
    [authResult, customFetch]
  );

  const postGrowthAwardAnswer = useCallback(
    async (appId: number, questionId: string, answer: any, dataType: any) => {
      const url = `${baseUrl}applications/${appId}/questionresponse/${questionId}`;

      let postInfo = {};
      postInfo = {
        applicationId: Number(appId),
        questionId: questionId,
        response:
          dataType == 'int'
            ? Number(answer)
            : dataType == 'string'
              ? answer
              : dataType == 'single select'
                ? [Number(answer)]
                : answer,
      };

      const response = await customFetch(url, {
        method: 'PUT',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },

        body: JSON.stringify(postInfo),
      });

      const results = await response;
      return response;
    },
    [authResult, customFetch]
  );

  return {
    getGrowthAward,
    getGrowthAwardResponses,
    postGrowthAwardResponses,
    postGrowthAwardAnswer,
    deleteGrowthAwardResponse,
  };
}
